import { supabase } from '@/lib/supabase/client'

export type Sale = {
  id: string
  created_at: string
  amount: number
}

export const getSales = async (startDate?: Date) => {
  let query = supabase
    .from('sales')
    .select('*')
    .order('created_at', { ascending: true })

  if (startDate) {
    query = query.gte('created_at', startDate.toISOString())
  }

  const { data, error } = await query

  return { data: data as Sale[], error }
}
